import { render } from "./RefRolesPage.vue?vue&type=template&id=65074574&scoped=true"
import script from "./RefRolesPage.vue?vue&type=script&lang=js"
export * from "./RefRolesPage.vue?vue&type=script&lang=js"

import "./RefRolesPage.vue?vue&type=style&index=0&id=65074574&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65074574"]])

export default __exports__